import React from 'react';
import _ from 'lodash';

import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';

import * as UserDetailSection from './UserDetailSection/UserDetailSection';
import * as dataService from './dataService';



export const FC: React.FC = () => {
  const queryTuple = dataService.useQuery();
  const [selectedUserId, setSelectedUserId] = React.useState('');



  React.useEffect(
    () => {
      if (!selectedUserId && !_.isEmpty(queryTuple.data.users)) {
        setSelectedUserId(_.first(queryTuple.data.users)?.id ?? '');
      }
    },
    [selectedUserId, queryTuple.data.users]
  );



  return (
    <Grid container>
      <Grid
        item
        xs={3}>
        <List>
          {_.map(queryTuple.data.users, user => (
            <ListItem key={user.id}>
              <ListItemButton
                selected={user.id === selectedUserId}
                onClick={_.partial(setSelectedUserId, user.id)}>
                <ListItemText
                  primary={user.email}
                  secondary={`${user.roleCount} assigned roles`} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

      </Grid>

      <Grid
        item
        xs={9}>
        {selectedUserId && (
          <UserDetailSection.FC siteUserId={selectedUserId} />
        )}
      </Grid>
    </Grid>
  );
};
